export const examAdminRolePermissions = {
  catalogTitle: "角色目录",
  catalogLoadFailed: "角色目录读取失败",
  catalogContractInvalid: "角色目录合同异常",
  catalogContractDescription: "后端必须显式返回 role-catalog.roles 数组；开发阶段不使用空目录兜底。",
  matrixTitle: "权限矩阵",
  matrixBlocked: "角色目录异常，权限矩阵已暂停",
  permissionColumn: "权限点",
  allowed: "允许",
  denied: "拒绝",
  status: {
    active: "启用",
    inactive: "停用",
  },
  permissions: {
    dashboard: "工作台",
    candidateUsers: "考生用户目录",
    users: "用户管理",
    resetUserPassword: "重置用户密码",
    impersonateCandidate: "代入考生",
    system: "系统设置",
    auditLogs: "审计日志",
    questions: "题库管理",
    archiveQuestions: "归档题目",
    deleteQuestions: "删除题目",
    publishQuestions: "发布题目",
    questionExperience: "题目体验治理",
    papers: "试卷管理",
    exams: "考试管理",
    execution: "运行监控",
    docker: "环境实例",
    assets: "资产中心",
    review: "阅卷复核",
  },
};
